import { COMPANY_GROUPS_NAMES, COMPANY_REFERENCE_MATERIALS_NAMES } from '@/config/router/routerMapConfig'
import { MAP_LAYERS_MAPPING } from './map/map-layers-config'

export const COMPANY_LICENSE_MODULES = {
	BASE: 'base',
	GPS_MONITORING: 'gps_monitoring',
	LAND_BANK: 'land_bank',
	STORAGE: 'storage',
	SATELLITE_MONITORING: 'satellite_monitoring',
	REPAIRING: 'repairing',
	LOGISTICS: 'logistics',
	CROP_PRODUCTION: 'crop_production',
	EXPORT_DENY: 'export_deny',
}

export const AVAILABLE_GROUPS_BY_LICENSE_MODULES = {
	[COMPANY_LICENSE_MODULES.BASE]: [
		COMPANY_GROUPS_NAMES.TEST,

		COMPANY_GROUPS_NAMES.PLANNING__PROJECTS,

		COMPANY_GROUPS_NAMES.WORKS__MY_TASKS,
		COMPANY_GROUPS_NAMES.WORKS__CONTROL,
		COMPANY_GROUPS_NAMES.WORKS__PROJECT_TASKS,

		COMPANY_GROUPS_NAMES.CAR_PARK__TECHNIQUE_AND_EQUIPMENT,

		COMPANY_GROUPS_NAMES.REPORTS__ALL_WORKS,
		COMPANY_GROUPS_NAMES.REPORTS__TECHNIQUE_AND_DEVICES,
		COMPANY_GROUPS_NAMES.REPORTS__ECONOMY,

		COMPANY_GROUPS_NAMES.REAL_ESTATE__INFRASTRUCTURE,
	],

	[COMPANY_LICENSE_MODULES.GPS_MONITORING]: [
		COMPANY_GROUPS_NAMES.CAR_PARK__GPS_MONITORING,
		COMPANY_GROUPS_NAMES.REPORTS__TECHNIQUE_AND_DEVICES,
	],

	[COMPANY_LICENSE_MODULES.LAND_BANK]: [
		COMPANY_GROUPS_NAMES.REAL_ESTATE__LAND_BANK,
	],

	[COMPANY_LICENSE_MODULES.STORAGE]: [
		COMPANY_GROUPS_NAMES.REPORTS__INVENTORY_CONTROL,
	],

	[COMPANY_LICENSE_MODULES.SATELLITE_MONITORING]: [
		COMPANY_GROUPS_NAMES.REPORTS__CONDITION_OF_CROPS,
		COMPANY_GROUPS_NAMES.REAL_ESTATE__LAND_BANK,
	],

	[COMPANY_LICENSE_MODULES.REPAIRING]: [
		COMPANY_GROUPS_NAMES.PLANNING__MAINTENANCE,
		COMPANY_GROUPS_NAMES.WORKS__REPAIR,
	],

	[COMPANY_LICENSE_MODULES.LOGISTICS]: [
		COMPANY_GROUPS_NAMES.CAR_PARK__GPS_MONITORING,
		COMPANY_GROUPS_NAMES.PLANNING__TRANSPORTATION,
		COMPANY_GROUPS_NAMES.WORKS__LOGISTICS,
		COMPANY_GROUPS_NAMES.REPORTS__TECHNIQUE_AND_DEVICES,
	],

	[COMPANY_LICENSE_MODULES.CROP_PRODUCTION]: [
		COMPANY_GROUPS_NAMES.CAR_PARK__GPS_MONITORING,
		COMPANY_GROUPS_NAMES.PLANNING__CROP_PRODUCTION,
		COMPANY_GROUPS_NAMES.PLANNING__TRANSPORTATION,
		COMPANY_GROUPS_NAMES.WORKS__FIELD,
		COMPANY_GROUPS_NAMES.WORKS__LOGISTICS,
		COMPANY_GROUPS_NAMES.REPORTS__TECHNIQUE_AND_DEVICES,
		COMPANY_GROUPS_NAMES.REAL_ESTATE__LAND_BANK,
	],
}

export const AVAILABLE_REFERENCE_MATERIALS_BY_LICENSE_MODULES = {
	[COMPANY_LICENSE_MODULES.BASE]: [
		COMPANY_REFERENCE_MATERIALS_NAMES.INFRASTRUCTURE__GROUPS,
		COMPANY_REFERENCE_MATERIALS_NAMES.INFRASTRUCTURE__TAGS,

		COMPANY_REFERENCE_MATERIALS_NAMES.STAFF__LIST,
		COMPANY_REFERENCE_MATERIALS_NAMES.STAFF__DEPARTMENTS,
		COMPANY_REFERENCE_MATERIALS_NAMES.STAFF__GROUPS,
		COMPANY_REFERENCE_MATERIALS_NAMES.STAFF__ROLES,
		COMPANY_REFERENCE_MATERIALS_NAMES.STAFF__WORKS_SHIFTS,

		COMPANY_REFERENCE_MATERIALS_NAMES.RESOURCES__LIST,
		COMPANY_REFERENCE_MATERIALS_NAMES.RESOURCES__MATERIALS_CATEGORIES,
		COMPANY_REFERENCE_MATERIALS_NAMES.RESOURCES__MATERIALS_TAGS,
		COMPANY_REFERENCE_MATERIALS_NAMES.RESOURCES__CARGO_TAGS,

		COMPANY_REFERENCE_MATERIALS_NAMES.CAR_PARK__MACHINES_GROUPS,
		COMPANY_REFERENCE_MATERIALS_NAMES.CAR_PARK__EQUIPMENT_GROUPS,
		COMPANY_REFERENCE_MATERIALS_NAMES.CAR_PARK__LOGISTIC_ROUTE_TAGS,

		COMPANY_REFERENCE_MATERIALS_NAMES.COUNTERPARTIES__LIST,
		COMPANY_REFERENCE_MATERIALS_NAMES.COUNTERPARTIES__GROUPS,

		COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__SERVICE_PAYMENT,
		COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__MATERIAL_PRODUCTION,
		COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__MATERIAL_CONSUMPTIONS,
		COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__STAFF_PAYMENT,
		COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__PRODUCTIVITY,
		COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__QUALITY,

		COMPANY_REFERENCE_MATERIALS_NAMES.FINANCE__CATEGORIES,
		COMPANY_REFERENCE_MATERIALS_NAMES.FINANCE__GROUPS,
		COMPANY_REFERENCE_MATERIALS_NAMES.FINANCE__TAGS,

		COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__LIST,
		COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__CATEGORIES,
		COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__COST_CATEGORIES,
		COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__REPORT_LINK_TYPES,
		COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__MEASURE_TYPES,
		COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__REPORT_PHOTO_TYPES,
		COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__REPORT_DOCUMENT_TYPES,
		COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__REGULATION_TAGS,
		COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__REGULATION_STAGE_TAGS,
		COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__INCIDENT_TAGS,
	],

	[COMPANY_LICENSE_MODULES.GPS_MONITORING]: [],

	[COMPANY_LICENSE_MODULES.LAND_BANK]: [
		COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__FIELD_TAGS,
		COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_PURPOSES,
		COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_OWNERSHIP_TYPES,
		COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_CATEGORIES,
		COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_ACTIONS,
		COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_DOCUMENT_TYPES,
	],

	[COMPANY_LICENSE_MODULES.STORAGE]: [],

	[COMPANY_LICENSE_MODULES.SATELLITE_MONITORING]: [],

	[COMPANY_LICENSE_MODULES.REPAIRING]: [],

	[COMPANY_LICENSE_MODULES.LOGISTICS]: [],

	[COMPANY_LICENSE_MODULES.CROP_PRODUCTION]: [],
}

export const AVAILABLE_LAYER_TYPES_BY_LICENSE_MODULES = {
	[COMPANY_LICENSE_MODULES.BASE]: [
		MAP_LAYERS_MAPPING.INFRASTRUCTURES,
	],
	[COMPANY_LICENSE_MODULES.GPS_MONITORING]: [
		MAP_LAYERS_MAPPING.TRACKS,
	],
	[COMPANY_LICENSE_MODULES.LAND_BANK]: [
		MAP_LAYERS_MAPPING.FIELDS,
		MAP_LAYERS_MAPPING.LANDS,
	],
	[COMPANY_LICENSE_MODULES.STORAGE]: [],
	[COMPANY_LICENSE_MODULES.SATELLITE_MONITORING]: [
		MAP_LAYERS_MAPPING.SATELLITES,
	],
	[COMPANY_LICENSE_MODULES.REPAIRING]: [],
	[COMPANY_LICENSE_MODULES.LOGISTICS]: [
		MAP_LAYERS_MAPPING.TRACKS,
	],
	[COMPANY_LICENSE_MODULES.CROP_PRODUCTION]: [
		MAP_LAYERS_MAPPING.CROPS,
		MAP_LAYERS_MAPPING.PLAN_FACT,
		MAP_LAYERS_MAPPING.LOGISTICS,
	],
}
